// Meta (Facebook / Instagram) login config, shared by the org-level connect flow on the
// Integrations page (AppsPage) and the per-competition flow on Distribution → Social
// (SocialChannelsTab). No video scopes — the backend only publishes image/carousel/story
// (BUS-2799 / BUS-2853). Keep these in one place so the app id and scopes can't drift.
export const FB_APP_ID = '3898513280471149'

export const FB_SCOPE =
  'business_management,pages_show_list,instagram_basic,pages_manage_posts,instagram_content_publish,pages_read_engagement'
